import LogoVirginVelocityFrequentFlyer from '~/react/components/Logo/LogoVirginVelocityFrequentFlyer'
import LogoQantasBusinessRewards from '~/react/components/Logo/LogoQantasBusinessRewards'
import LogoSingaporeAirlinesKrisFlyer from '~/react/components/Logo/LogoSingaporeAirlinesKrisFlyer'

export default function useRedemptionPartnerLogo({redemptionPartnerKey}) {
  let image
  switch (redemptionPartnerKey) {
    case 'QBR':
      image = LogoQantasBusinessRewards
      break
    case 'VABF':
      image = LogoVirginVelocityFrequentFlyer
      break
    case 'KRI':
      image = LogoSingaporeAirlinesKrisFlyer
      break
    default:
      image = LogoQantasBusinessRewards
  }
  return image
}
